import React, { useState } from 'react';
import './Tooltip.css';

interface TooltipProps {
    content: string;
    children: React.ReactNode;
    position?: 'top' | 'bottom' | 'left' | 'right';
    delay?: number;
}

export function Tooltip({ content, children, position = 'top', delay = 200 }: TooltipProps) {
    const [visible, setVisible] = useState(false);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    const show = () => {
        const t = setTimeout(() => setVisible(true), delay);
        setTimer(t);
    };

    const hide = () => {
        if (timer) clearTimeout(timer);
        setVisible(false);
    };

    return (
        <div className="tooltip-container" onMouseEnter={show} onMouseLeave={hide}>
            {children}
            {visible && content && (
                <div className={`tooltip-bubble tooltip-${position}`}>
                    {content}
                </div>
            )}
        </div>
    );
}
